import styled from 'styled-components';

import TxtField01 from 'dc/TxtField01';

export const DateInput = styled(TxtField01)`
  background-color: #fff;
  width: 288px;
`;
